import React from 'react'
import { EditableSwitch, EditableTextField } from '../common/EditableComponents'
import { TableRow, TableCell, Button } from '@material-ui/core'
import { TableCellWithSwitch, TableCellWithTextField } from '../common/PureItems'
import { ColorSwatch, EditableColorPicker } from '../common/ColorPicker'
import ModalDialog from '../common/ModalDialog'

const RegionDispatchItem = (props) => {
  const {
    data,
    onChange,
    editRegion,
    getmodalDeleteRegion,
    handleClose,
    onConfirm,
    onColorChange,
    modalDeleteRegion,
    editMode,
    messageDeleteRegion,
  } = props

  return (
    <TableRow>
      <TableCell className="cell-wrap-word">
        {' '}
        {/* add editable input - */}
        <TableCellWithTextField
          valueToRender={data.name}
          value={data.name}
          editMode={editMode}
          onChange={onChange('name')}
          type="text"
          InputLabelProps={{
            shrink: true,
          }}
        />
      </TableCell>

      <TableCell className="cell-wrap-word">
        {/* add editable input - s*/}
        <TableCellWithTextField
          valueToRender={data.deliveryFee}
          value={data.deliveryFee}
          editMode={editMode}
          onChange={onChange('deliveryFee')}
          type="number"
          InputLabelProps={{
            shrink: true,
          }}
        />
      </TableCell>

      <TableCell className="cell-wrap-word">
        <EditableTextField
          valueToRender={data.minOrderAmount}
          value={data.minOrderAmount}
          editMode={editMode}
          onChange={onChange('minOrderAmount')}
          type="number"
          InputLabelProps={{
            shrink: true,
          }}
        />
      </TableCell>

      <TableCell className="cell-wrap-word">
        <EditableTextField
          valueToRender={data.freeDeliveryAfter}
          value={data.freeDeliveryAfter}
          editMode={editMode}
          onChange={onChange('freeDeliveryAfter')}
          type="number"
          InputLabelProps={{
            shrink: true,
          }}
        />
      </TableCell>

      <TableCell className="cell-wrap-word">
        {Boolean(data.openAt) && Boolean(data.closeAt) ? (
          <div>
            <EditableTextField
              valueToRender={`${data.openAt}`}
              value={data.openAt}
              editMode={editMode}
              onChange={onChange('openAt')}
              type="time"
              InputLabelProps={{
                shrink: true,
              }}
            />
            <span> - </span>
            <EditableTextField
              valueToRender={`${data.closeAt}`}
              value={data.closeAt}
              editMode={editMode}
              onChange={onChange('closeAt')}
              type="time"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </div>
        ) : (
          <span style={{ fontStyle: 'italic' }}>Undefined</span>
        )}
      </TableCell>

      <TableCell className="cell-wrap-word">
        {Boolean(data.kmlColor) ? (
          <EditableColorPicker
            valueToRender={<ColorSwatch color={data.kmlColor} />}
            color={data.kmlColor}
            onColorChange={onColorChange('kmlColor')}
            editMode={editMode}
          />
        ) : (
          <span style={{ fontStyle: 'italic' }}>Undefined</span>
        )}
      </TableCell>

      <TableCell className="cell-wrap-word">
        <TableCellWithSwitch
          valueToRender={data.regionDefault ? 'Yes' : 'No'}
          value={data.regionDefault}
          editMode={editMode}
          onChange={onChange('regionDefault', true)}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </TableCell>

      <TableCell>
        <EditableSwitch
          valueToRender={data.active ? 'Yes' : 'No'}
          value={data.active}
          editMode={editMode}
          onChange={onChange('active', true)}
        />
      </TableCell>

      <TableCell className="cell-wrap-word">
        {/*<EditActionComponent
                            onSave={onSave}
                            onCancel={onCancel}
                            onEdit={props.enableEdit}
                            editMode={editMode}
                            onClick={editRegion}
                        />*/}
        <Button
          className="primary-button margin"
          onClick={() => {
            editRegion(data.id)
          }}
        >
          Edit
        </Button>
        <Button className="danger-button margin" onClick={getmodalDeleteRegion}>
          Delete
        </Button>
      </TableCell>

      <ModalDialog
        title={messageDeleteRegion}
        ref={(c) => {
          modalDeleteRegion(c)
        }}
        onConfirm={onConfirm}
        //onClose={onClose}
        onClose={handleClose}
        confirmText="Yes"
        cancelText="No"
      />
    </TableRow>
  )
}

export default RegionDispatchItem



// WEBPACK FOOTER //
// ./src/components/Regions/RegionDispatchItem.js